// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"4433a78b","56":"66233d03","149":"4cbde527","164":"1b902657","209":"c0e294de","405":"799fe988","449":"f565169c","477":"78ec9207","614":"39f07804","705":"3d132375","747":"ddf24818","841":"2982e346"}[chunkId] + ".chunk.js";
};